// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"_382a","header":"_1lMk","subHeader":"_2sWr","list":"_3FP2","endUserType":"_1G8q","radio":"Xcol","info":"_1P__"};


//////////////////
// WEBPACK FOOTER
// ./src/features/MobileServices/MobileServiceForm/UploadDocumentsStep/UploadDocumentsStep.scss
// module id = UIXL
// module chunks = 0